import styles from "./HomePage.module.css";
import { Link } from "react-router-dom";

const HomePage = () => {
    //<Link to = "/howitworks" className = {styles.option}>How It Works?</Link>
    return (
        <div className = {styles.body}>
            <div className = {styles.navbar}>
                <h1 className = {styles.truthcreds}>TruthCreds</h1>
                <Link to = "/mainpage/" className = {styles.option}>Get Started</Link>
                <Link to = "/aboutteam" className = {styles.option}>About Team</Link>
            </div>
            <div className = {styles.firstPage}>
                <h1 className = {styles.tagline}>
                    We are battling online misinformation
                </h1>
            </div>
        </div>
    )
}

export default HomePage;